module.exports = __webpack_public_path__ + "media/Images/faq-header-image-002-f3084a452e2c29d39f3df84d44aa9858.jpg";